import { Collection } from '@features/Collection';
import { useCollectionFavorites } from '@features/Collection/hooks/useCollectionFavorites';
import { HeartFilledIcon, HeartIcon } from '@radix-ui/react-icons';
import { IconButton, IconProps } from '@radix-ui/themes';
import React, { ForwardRefExoticComponent, RefAttributes } from 'react';

type Bookmark = 'true' | 'false';

const ICON_FOR_BOOKMARK: {
    [key in Bookmark]: ForwardRefExoticComponent<
        IconProps & RefAttributes<SVGSVGElement>
    >;
} = {
    true: HeartFilledIcon,
    false: HeartIcon,
};

interface BookmarkSwitchProps {
    onChange?: (isBookmarked: boolean) => void;
    collection: Collection;
}

export const BookmarkSwitch = ({
    onChange,
    collection,
}: BookmarkSwitchProps) => {
    const { checkIsFavorite, toggleFavorite } = useCollectionFavorites();
    const isBookmarked = checkIsFavorite(collection.proscopeId);
    const Icon = ICON_FOR_BOOKMARK[String(isBookmarked) as Bookmark];

    const handleOnClick = (event: React.MouseEvent<SVGSVGElement>) => {
        event.stopPropagation();
        const nextState = !isBookmarked;

        toggleFavorite(collection.proscopeId, nextState);
        onChange?.(nextState);
    };

    return (
        <IconButton
            variant='ghost'
            style={{ cursor: 'pointer' }}
            radius='full'
            asChild
        >
            <Icon onClick={handleOnClick} width={'24'} height={'24'} />
        </IconButton>
    );
};
